import { ChipProps } from './types'
import { makeStyles, css } from '@conexasaude/styles'
import typographyToStyle from '@/utils/typographyToStyle'
import { themeToStyle } from './utils'

export const useStyles = makeStyles<{
  hasIcon: boolean
  variant: ChipProps['variant']
}>({
  root: css`
    display: inline-flex;
  `,
  chip: (theme, { variant, hasIcon }) => css`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: ${hasIcon ? '107px' : '59px'};
    height: 38px;
    padding: ${theme.spacing(1)}px ${theme.spacing(2)}px;
    cursor: pointer;
    pointer-events: all;
    box-sizing: border-box;
    border-radius: ${theme.borderRadius.pill};
    outline: ${themeToStyle(variant, theme.colors).outline};
    border: ${themeToStyle(variant, theme.colors).border};
    background: ${themeToStyle(variant, theme.colors).background};

    > span,
    > label {
      color: ${themeToStyle(variant, theme.colors).label};
      margin: ${hasIcon ? '0 8px' : '0'};
    }

    &:active {
      background: ${themeToStyle(variant, theme.colors).active.background};
      border-color: ${themeToStyle(variant, theme.colors).active.borderColor};
      > span,
      > label {
        color: ${themeToStyle(variant, theme.colors).active.label};
      }
    }

    &:hover {
      > span,
      > label {
        color: ${themeToStyle(variant, theme.colors).hover.label};
      }
    }
  `,

  iconBox: css`
    outline: none;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    z-index: 2;
    margin: 0 !important;
    display: inline-flex;
    > svg {
      width: 16px;
      height: 16px;
    }
  `,
  label: theme => css`
    ${typographyToStyle(theme.typography.body2)};
    transition: color 250ms ease-in-out;
    z-index: 1;
  `,
  input: css`
    position: absolute;
    cursor: pointer;
    pointer-events: all;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
    margin: 0;
  `,
  checked: (theme, { variant }) => css`
    background: ${themeToStyle(variant, theme.colors).active.background};
    border-color: ${themeToStyle(variant, theme.colors).active.borderColor};
    > span,
    > label {
      color: ${themeToStyle(variant, theme.colors).active.label};
    }
  `,
  disabled: (theme, { variant }) => css`
    background: ${themeToStyle(variant, theme.colors).disabled.background};
    border-color: ${themeToStyle(variant, theme.colors).disabled.borderColor};
    cursor: not-allowed;
    pointer-events: none;

    > span,
    > label {
      color: ${themeToStyle(variant, theme.colors).disabled.label};
    }

    > input {
      cursor: not-allowed;
      pointer-events: none;
    }
  `,
})

export default useStyles
